import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HelpersService } from '../shared/helpers.service';

@Injectable({
  providedIn: 'root'
})
export class RepositoryQueryGuard  {

  constructor(
    private router: Router, private helpersService: HelpersService) {}

  //Ta guard pazi, da so query parametri v pathu /repository nastavljeni, drugače te ne spusti naprej na željeno pot.
  //V if spodaj se morajo dodati novi state-url.includes za nov primer.
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      if(state.url.includes('podrobno-lumina-POS')) {
        if(state.root.queryParams.modulId && state.root.queryParams.modulNameSmall &&
          state.root.queryParams.serverCode && state.root.queryParams.companyId) {
         /*console.log("modulId = " + state.root.queryParams.modulId);
         console.log("modulNameSmall = " + state.root.queryParams.modulNameSmall);
         console.log("serverCode = " + state.root.queryParams.serverCode);
         console.log("companyId = " + state.root.queryParams.companyId);*/
         return true;
       } else {
         this.router.navigate(['/odlagalisce']);
         this.helpersService.openSnackBar("Na to pot brez parametrov ne bo šlo!", "Zapri");
         return false;
       }
      } else if(state.url.includes('podrobno-server')) {
        if(state.root.queryParams.modulId && state.root.queryParams.companyId) {
         return true;
       } else {
         this.router.navigate(['/odlagalisce']);
         this.helpersService.openSnackBar("Na to pot brez parametrov ne bo šlo!", "Zapri");
         return false;
       }
      }

  }

}
